
import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import XmlController from "@/plugins/uyap-plugin/takip_ac/XmlController";
import { VForm } from "@/types";
import * as xml2js from "xml2js";
import { JobType } from "@/enum/JobType";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import { ProgramPaths } from "@/enum/ProgramPaths";
import Crypto from "crypto";

interface JobItem {
  _id: number;
  file_name: string;
  created_at: string;
  file_count: number;
  showProgress?: boolean;
  value?: number;
  faiz_turu_var_mi?: boolean;
}

interface Kademe {
  otzid: string;
  ottarih: string;
  ot2oran: string;
  ot2faizid: string;
}

interface Faiz {
  faiz_adi: string;
  faiz_id: string;
  faiz_aylik: string;
}

interface FaizGrup {
  faiz_kademeleri: Kademe[];
  faiz_listesi: Faiz[];
}

interface FaizTurleriResponse {
  faiz_turleri: {
    faiz: Faiz | Faiz[];
    faiz_kademeleri: {
      kademe?: {
        ot2id: string;
        ot2tarih: string;
        ot2oran: string;
        ot2faizid: string;
      } | Array<{
        ot2id: string;
        ot2tarih: string;
        ot2oran: string;
        ot2faizid: string;
      }>;
    }[];
  };
}

interface ResultType {
  faiz_turleri: FaizGrup[];
}

@Component({
  components: { DeleteDialog }
})
export default class AktarView extends Vue {
  @Ref("form") readonly xmlForm!: VForm;
  valid = false;
  onFly = false;
  xml: File | null = null;
  xmlFiles: File[] = [];
  items: JobItem[] = [];
  loadItems = false;
  interval: any = {};
  value = 60;
  showProgress = false;
  fileName: string = "";
  uploadProgress = 0;
  alert = false;
  alertMessage = "";
  showDialog = false;
  showSecondaryDialog = false;
  tab = 0;
  countdown: number = 120;
  progress: number = 100;
  errorFiles: { fileName: string; message: string }[] = [];
  currentFileIndex: number = 0;
  fileQueue: File[] = [];
  dialogTitle: string = "";
  dialogMessage: string = "";
  dialogConfirmText: string = "Evet";
  dialogDismissText: string = "Hayır";
  dialogConfirmAction: (() => void) | null = null;
  dialogDismissAction: (() => void) | null = null;
  currentFileName: string = "Yükleme hazırlanıyor...";
  currentFileStatus: string = "Lütfen bekleyin...";
  fileStatuses: { [key: string]: 'success' | 'error' | 'pending' } = {};
  evrakStatuses: { [key: string]: 'success' | 'error' | 'pending' } = {};
  currentStep: number = 1;
  currentChunk: number = 0;
  totalChunks: number = 0;
  chunkProgress: number = 0;
  emptyTag: undefined;
  successCount: number = 0;
  errorCount: number = 0;
  jobArray: any[] = [];
  timer: ReturnType<typeof setInterval> | null = null;
  fileInputKey = 0;


  headers = [
    { text: "İşlem No", value: "id" },
    { text: "Dosya Adı", value: "file_name" },
    { text: "Oluşturulma Tarihi", value: "created_at" },
    { text: "Dosya Sayısı", value: "file_count" },
    { text: "İşlemler", value: "actions", align: "end" }
  ];

  mounted() {
    this.load();
    window.addEventListener("beforeunload", this.preventNavigation);
    window.addEventListener("click", this.showSnackbarOnInteraction);
  }

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNavigation);
    window.removeEventListener("click", this.showSnackbarOnInteraction);
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  @Watch("showDialog")
  onShowDialogChanged(newVal: boolean) {
    console.log("show dialog");
    if (newVal) {
      this.startCountdown();
    } else {
      this.resetCountdown();
    }
  }

  async load() {
    this.loadItems = true;
    try {
      // @ts-ignore
      this.items = await this.$http.get("/api/v1/job?type_id=2");
    } catch (error) {
      console.error('Error loading items:', error);
    } finally {
      this.loadItems = false;
    }
  }

  setProgress(item: JobItem) {
    this.items.forEach((item) => {
      this.$set(item, "showProgress", false);
      this.$set(item, "value", 60);
    });

  }

  fileRule(file: File | null): boolean | string {
    if (!file) return "Lütfen bu alanı doldurun.";
    const fileName = file.name || '';
    const fileExtension = fileName.split('.').pop()?.toLowerCase();
    if (fileExtension === 'xml') return true;
    return "Sadece xml dosya yüklenebilir.";
  }

  bolArray(dizi: Array<any>, boyut: number): Array<Array<any>> {
    let sonuc: Array<Array<any>> = [];
    for (let i = 0; i < dizi.length; i += boyut) {
      sonuc.push(dizi.slice(i, i + boyut));
    }
    return sonuc;
  }

  detay(item: JobItem) {
    this.$router.push(ProgramPaths.ofispro + "/aktar-detay/" + item._id);
  }

  async onFileChange(files: File[]) {
    if (files && files.length && !this.onFly) {
      this.xmlFiles = files;
      this.fileName = files[0].name;
      this.errorFiles = [];
      files.forEach(file => {
        this.$set(this.fileStatuses, file.name, 'pending');
        this.$set(this.evrakStatuses, file.name, 'pending');
      });
    }
  }

  onDrop(event: DragEvent) {
    const files = event.dataTransfer!.files;
    if (files.length) {
      this.xmlFiles = Array.from(files);
      this.autoUpload();
    }
  }

  preventNavigation(event: BeforeUnloadEvent) {
    if (this.onFly) {
      event.preventDefault();
      event.returnValue = "";
    }
  }

  showSnackbarOnInteraction(event: Event) {
    if (this.onFly) {
      event.preventDefault();
    }
  }


  handleDialogConfirm() {
    this.showDialog = false;
    if (this.dialogConfirmAction) {
      this.dialogConfirmAction();
    }
  }

  handleDialogDismiss() {
    this.showDialog = false;
    if (this.dialogDismissAction) {
      this.dialogDismissAction();
    }
  }


  finishProcess() {
    this.showSecondaryDialog = true;
  }

  async autoUpload() {
    if (this.onFly || this.xmlFiles.length === 0) {
      console.log("İşlem zaten devam ediyor veya dosya yok");
      return;
    }

    console.log("autoUpload başladı");

    try {
      if (this.tab === 0) {
        console.log("xmlAktarMultiple başlatılıyor");
        await this.xmlAktarMultiple();
      }
    } catch (error) {
      console.error("Dosya yükleme hatası:", error);
      this.$toast.error("Dosya yükleme sırasında bir hata oluştu: " + error.message);
    }
  }

  temizleXML(xmlString: string): string {
    return xmlString
      // XML'deki geçersiz karakterleri temizle
      .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '')
      // Whitespace hatalarını düzelt
      .replace(/(\s+)([^\s=]+)(\s*)=(\s*)([^\s=]+)/g, '$1$2=$5')
      // & karakterini düzgün entity'lere dönüştür
      .replace(/&(?!amp;|lt;|gt;|quot;|apos;)/g, '&amp;')
      // Özel karakterleri düzelt
      .replace(/[\uFFFD\uFFFE\uFFFF]/g, '');
  }

  showBrokenXmlDialog() {
    this.alertMessage = "Bozuk XML dosyası yüklenemedi. Lütfen dosyanızı kontrol edin ve tekrar deneyin.";
    this.alert = true;
  }


  async delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async xmlAktarMultiple() {
    if (this.onFly) {  console.warn("Uyarı: Bir işlem zaten devam ediyor.");
      return false;
    }

    console.log("xmlAktarMultiple başladı");
    this.errorFiles = [];
    this.currentFileIndex = 0;
    this.jobArray = [];
    this.onFly = true;

    this.xmlFiles.forEach(file => {
      this.$set(this.fileStatuses, file.name, 'pending');
    });

    try {
      if (!this.xmlFiles || this.xmlFiles.length === 0) {
        throw new Error("Yüklenecek dosya seçilmedi");
      }

      const totalFiles = this.xmlFiles.length;

      for (let i = 0; i < totalFiles; i++) {
        const file = this.xmlFiles[i];

        this.updateUIStatus(file.name, i, totalFiles);

        this.xml = file;
        this.fileName = file.name;

        try {
          await this.xmlAktar();

          this.$set(this.fileStatuses, file.name, 'success');
          console.log(`${file.name} başarıyla işlendi`);
        } catch (error) {
          this.$set(this.fileStatuses, file.name, 'error');
          this.errorFiles.push({
            fileName: file.name,
            message: error.message || "Bilinmeyen bir hata oluştu"
          });
          console.error(`${file.name} işlenirken hata:`, error);
        }

        const completedFiles = i + 1;
        this.uploadProgress = (completedFiles / totalFiles) * 100;

        //await this.$nextTick();
      }

      const batchSent = await this.sendJobsInBatches(this.jobArray);
      if (!batchSent) {
        this.$toast.error(`Dosyalar görevlere eklenemedi.`);
        return;
      }
      this.updateUIStatus("İşlem tamamlandı", totalFiles, totalFiles);
      this.$toast.warning(`İşlem tamamlandı. ${this.errorFiles.length} dosya hatalı.`);

      return true;
    } catch (error) {
      console.error("Genel işlem hatası:", error);
      this.$toast.error("Dosya işleme sırasında hata oluştu: " + error.message);
      return false;
    } finally {
      this.onFly = false;
      this.uploadProgress = 100;
      await this.load();
    }
  }

  // toplu-job request body limitleri (byte). Backend proxy/PHP sınırlarına göre
  // batch başına ~15 MB hedef; tek bir parça > 4 MB ise taşmaya izin verilmez,
  // yeni batch açılır. ≤ 4 MB parçalarda esneklik tanınıp mevcut batch'e eklenir.
  private static readonly TOPLU_JOB_BATCH_LIMIT = 15 * 1024 * 1024;
  private static readonly TOPLU_JOB_LARGE_ITEM_LIMIT = 4 * 1024 * 1024;

  private calculateJobSize(job: any): number {
    try {
      return new Blob([JSON.stringify(job)]).size;
    } catch {
      return JSON.stringify(job).length;
    }
  }

  private async postTopluJobBatch(batch: any[]): Promise<boolean> {
    let retries = 3;
    while (retries > 0) {
      try {
        const response = await this.$http.post('/api/v1/toplu-job', { data: batch });
        console.log("toplu-job batch gönderildi:", { count: batch.length, response });
        return true;
      } catch (error) {
        retries--;
        console.error("toplu-job gönderim hatası:", error);
        if (retries === 0) {
          const msg = (error as any)?.response?.data?.error || (error as any)?.message || "Bilinmeyen hata";
          this.$toast.error("Dosya parçası gönderilirken hata oluştu: " + msg);
          return false;
        }
      }
    }
    return false;
  }

  async sendJobsInBatches(jobs: any[]): Promise<boolean> {
    if (!jobs || jobs.length === 0) return true;

    const BATCH_LIMIT = AktarView.TOPLU_JOB_BATCH_LIMIT;
    const LARGE_ITEM_LIMIT = AktarView.TOPLU_JOB_LARGE_ITEM_LIMIT;

    let currentBatch: any[] = [];
    let currentSize = 0;

    const flush = async (): Promise<boolean> => {
      if (currentBatch.length === 0) return true;
      const ok = await this.postTopluJobBatch(currentBatch);
      currentBatch = [];
      currentSize = 0;
      return ok;
    };

    for (const job of jobs) {
      const size = this.calculateJobSize(job);

      if (currentSize + size > BATCH_LIMIT) {
        if (size > LARGE_ITEM_LIMIT) {
          if (!(await flush())) return false;
          currentBatch.push(job);
          currentSize = size;
        } else {
          // Küçük parça (≤ 4 MB) taşma toleransı: mevcut batch'e eklenir
          // ve batch hemen kapatılır. Aksi halde küçük parçalar birikerek
          // batch sınırsız şişer (snowball).
          currentBatch.push(job);
          currentSize += size;
          if (!(await flush())) return false;
        }
      } else {
        currentBatch.push(job);
        currentSize += size;
      }
    }

    return await flush();
  }

  async xmlAktar() {
    if (!this.xml) {
      console.error("Dosya seçilmedi");
      return;
    }
    console.log("xmlAktar called");
    try {
      this.uploadProgress = 0;
      this.chunkProgress = 0;
      console.log(`Başlıyor: ${this.fileName} dosyası okunacak`);

      let xmlContent;
      let faizTuruVarMi = false;
      let kasalar: any[] = [];

      try {
        this.currentStep = 1;
        this.updateUIStatus(`${this.fileName} okunuyor...`, this.currentFileIndex, this.xmlFiles.length);
        let xml = Object.assign(this.xml,{});
        xmlContent = await XmlController.readXmlWithEncoded(xml);
        xmlContent = this.temizleXML(xmlContent);
        //console.log("xmlContent",xmlContent);
        console.log(`${this.fileName} dosyası başarıyla okundu`);
      } catch (error) {
        console.error("Dosya okuma hatası:", error);
        this.showBrokenXmlDialog();
        throw error;
      }

      let data;
      try {
        this.currentStep = 2;
        this.updateUIStatus(`${this.fileName} işleniyor...`, this.currentFileIndex, this.xmlFiles.length);
        data = await this.optimizeXmlParsing(xmlContent);
        if (!data || !data.exchangeData) {
          throw new Error("Geçersiz XML yapısı: exchangeData bulunamadı.");
        }
        data = data.exchangeData;
        //console.log(`${this.fileName} XML verisi JSON'a dönüştürüldü`, data);
        const parsedDosyalar = Array.isArray(data.dosyalar?.dosya)
            ? data.dosyalar.dosya
            : data.dosyalar?.dosya
                ? [data.dosyalar.dosya]
                : [];

        for (const dosya of parsedDosyalar) {
          const rawEvraklar = dosya?.evraklar?.evrak;
          if (typeof rawEvraklar === "undefined") {
            continue;
          }

          const evraklar = Array.isArray(rawEvraklar) ? rawEvraklar : [rawEvraklar];
          const uploadedFiles = [];

          console.log("DOSYA EVRAKLARI", evraklar);
          for (const evrak of evraklar) {
            try {
              console.log("EVRAK", evrak);
              this.$spinner.message(evrak.fileName + " Yükleniyor ...");
              const file = await this.uploadFile(evrak);
              uploadedFiles.push(file);
            } catch (e) {
              this.$spinner.message("Evrak yüklenemedi ! " + e.message);
            }
          }

          dosya.evraklar = uploadedFiles;
        }

        if (data.faiz_turleri) {
          faizTuruVarMi = Array.isArray(data.faiz_turleri.faiz)
              ? data.faiz_turleri.faiz.length > 0
              : !!data.faiz_turleri.faiz;
        }
        console.log(`faizTuruVarMi for ${this.fileName}:`, faizTuruVarMi);

        if (data.kasalar?.kasa) {
          kasalar = Array.isArray(data.kasalar.kasa)
              ? data.kasalar.kasa
              : [data.kasalar.kasa];
        }
        console.log(`kasalar for ${this.fileName}:`, kasalar);
      } catch (error) {
        console.error("XML verisi JSON'a dönüştürülürken hata oluştu:", error);
        this.showBrokenXmlDialog();
        throw error;
      }

      if (!data.dosyalar || !data.dosyalar.dosya) {
        throw new Error("Geçersiz dosya yapısı: dosyalar veya dosya bulunamadı");
      }

      let dosyalar = Array.isArray(data.dosyalar.dosya)
          ? data.dosyalar.dosya
          : [data.dosyalar.dosya];

      dosyalar = dosyalar
          .map((dosya: any) => dosya ? { ...dosya } : null)
          .filter(Boolean);

      if (dosyalar.length === 0) {
        throw new Error("İşlenecek dosya bulunamadı");
      }

      this.currentStep = 3;
      this.updateUIStatus(`${this.fileName} aktarılıyor...`, this.currentFileIndex, this.xmlFiles.length);
      let bolunmusDosyalar = this.bolArray(dosyalar, 25);
      console.log(`${bolunmusDosyalar.length} parça işlenecek`);

      const totalChunks = bolunmusDosyalar.length;
      this.totalChunks = totalChunks;
      let uploadedChunks = 0;

      for (let bolunmusDosya of bolunmusDosyalar) {
        this.currentChunk = uploadedChunks + 1;
        if (!bolunmusDosya || bolunmusDosya.length === 0) {
          continue;
        }
        this.updateUIStatus(`${this.fileName} - Parça ${this.currentChunk}/${this.totalChunks} işleniyor...`, this.currentFileIndex, this.xmlFiles.length);
        let faizVerisi = [];
        if (data.faiz_turleri) {
          faizVerisi = this.faizTurleri(data);
        }

        let dosyaArgs = bolunmusDosya.map(dosya => ({
          ...dosya,
          faizler: faizVerisi,
          kart_no: dosya.kart_no,
          faiz_turu_var_mi: faizTuruVarMi
        }));

        let success = false;
        let retries = 3;
        while (retries > 0 && !success) {
          try {
            //let response = await this.$http.post('/api/v1/job', {
            //  file_name: this.fileName,
            //  type_id: JobType.IcwAktar,
            //  status: "WAITING",
            //  args: dosyaArgs,
            //  faiz_turu_var_mi: faizTuruVarMi
            //});
            this.jobArray.push(
                {
                  file_name: this.fileName,
                  type_id: JobType.IcwAktar,
                  status: "WAITING",
                  args: dosyaArgs,
                  faiz_turu_var_mi: faizTuruVarMi,
                  ...(uploadedChunks === 0 && kasalar.length > 0 ? { kasalar } : {})
                }
            );
            success = true;
          } catch (error) {
            retries--;
            console.error("Gönderim hatası:", error);
            //if (retries === 0) {
            //  this.$toast.error("Dosya parçası gönderilirken hata oluştu: " + (error.response ? error.response.data.error : error.message));
            //}
          }
        }
        uploadedChunks++;
        this.chunkProgress = (uploadedChunks / totalChunks) * 100;
      }

      if (this.items.length > 0) {
        this.setProgress(this.items[this.items.length - 1]);
      }

      this.$spinner.message(`${this.fileName} dosyası için Xml'den İcrapro'ya aktarma işlemi sıraya alındı.`);
    } catch (error) {
      console.error(`${this.fileName} için xmlAktar hatası:`, error);
      this.$toast.error(`${this.fileName} işleme sırasında hata oluştu: ` + error.message);
      this.fileStatuses[this.fileName] = 'error';
      throw error;
    }
  }

  async uploadFile(evrak: any){
    let formData = new FormData();
    let base64 = evrak["_"];
    let dokumanTuruId = "9";//Dayanak
    if(evrak.evrakTuru == "1")
      dokumanTuruId = "1";//Vekalet id si

    const Crypto = require('crypto');
    let hash = Crypto.createHash('sha1').update(base64).digest().toString('hex');
    let blob = this.$helper.base64toBlob(base64, evrak.mimeType);
    formData.append('aciklama', evrak.fileName);
    formData.append('name', evrak.fileName);
    formData.append('file', blob);
    formData.append('hash', hash);
    formData.append('dokuman_turu_id', dokumanTuruId);
    formData.append('mime_type', evrak.mimeType);
    return await this.$http.post('/api/v1/file', formData);
  }

  faizTurleri = (data: FaizTurleriResponse): ResultType[] => {
    try {
      const result: ResultType[] = [{
        faiz_turleri: [{
          faiz_kademeleri: [],
          faiz_listesi: []
        }]
      }];

      if (!data?.faiz_turleri) {
        console.warn("Veri yapısı eksik");
        return result;
      }

      const faizler: Faiz[] = [];
      if (Array.isArray(data.faiz_turleri.faiz)) {
        faizler.push(...data.faiz_turleri.faiz);
      } else if (data.faiz_turleri.faiz) {
        faizler.push(data.faiz_turleri.faiz);
      }

      result[0].faiz_turleri[0].faiz_listesi = faizler.map((faiz): Faiz => ({
        faiz_adi: faiz?.faiz_adi || "",
        faiz_id: faiz?.faiz_id || "",
        faiz_aylik: faiz?.faiz_aylik || ""
      }));

      const tumKademeler: Kademe[] = [];
      const kademelerList = data.faiz_turleri.faiz_kademeleri;
      if (kademelerList) {
        Object.values(kademelerList).forEach(kademelerGrubu => {
          if (!kademelerGrubu?.kademe) return;

          const kademeler = Array.isArray(kademelerGrubu.kademe)
              ? kademelerGrubu.kademe
              : [kademelerGrubu.kademe];

          kademeler.forEach(kademe => {
            if (kademe?.ot2id) {
              tumKademeler.push({
                otzid: kademe.ot2id || "",
                ottarih: kademe.ot2tarih || "",
                ot2oran: kademe.ot2oran || "",
                ot2faizid: kademe.ot2faizid || ""
              });
            }
          });
        });
      }
      result[0].faiz_turleri[0].faiz_kademeleri = tumKademeler;
      return result;

    } catch (error) {
      console.error("Veri işleme hatası:", error);
      return [{
        faiz_turleri: [{
          faiz_kademeleri: [],
          faiz_listesi: []
        }]
      }];
    }
  };

  updateUIStatus(status: string, currentIndex: number, totalFiles: number) {
    this.currentFileName = this.fileName;
    this.currentFileStatus = status;
    this.currentFileIndex = currentIndex;
    this.uploadProgress = ((currentIndex + 1) / totalFiles) * 100;
  }


  async optimizeXmlParsing(xmlContent: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const parser = new xml2js.Parser({
        explicitArray: false,
        mergeAttrs: true,
        emptyTag: undefined,
        async: true
      });
      parser.parseString(xmlContent, (err: any, result: any) => {
        if (err) {
          console.error("XML çevrim hatası:", err);
          reject(err);
        } else {
          resolve(result);
        }
      });
    });
  }

  startCountdown() {
    console.log("startCountdown");
    this.countdown = 120;
    this.progress = 100;
    this.timer = setInterval(() => {
      this.countdown--;
      this.progress = (this.countdown / 120) * 100;
      if (this.countdown <= 0) {
        clearInterval(this.timer!);
        this.autoDismiss();
      }
    }, 1000);
  }

  resetCountdown() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.progress = 100;
  }

  autoDismiss() {
    this.showDialog = false;
    this.showSecondaryDialog = true;
  }

  removeFile(index: number) {
    const fileName = this.xmlFiles[index].name;
    delete this.fileStatuses[fileName];
    delete this.evrakStatuses[fileName];
    this.xmlFiles.splice(index, 1);
  }

  formatFileSize(size: number): string {
    const units = ['B', 'KB', 'MB', 'GB'];
    let i = 0;
    while (size >= 1024 && i < units.length - 1) {
      size /= 1024;
      i++;
    }
    return `${size.toFixed(2)} ${units[i]}`;
  }

  anotherProcess() {
    this.showSecondaryDialog = false;
    this.xmlFiles = [];
    this.fileStatuses = {};
    this.evrakStatuses = {};
    this.errorFiles = [];
    this.fileName = "";
    this.fileInputKey++;
  }

  goHome() {
    this.showSecondaryDialog = false;
    this.$router.push('/ofispro');
  }

  get fileSuccessCount() {
    return Object.values(this.fileStatuses).filter(status => status === 'success').length;
  }

  get filePendingCount() {
    return Object.values(this.fileStatuses).filter(status => status === 'pending').length;
  }

  get fileErrorCount() {
    return Object.values(this.fileStatuses).filter(status => status === 'error').length;
  }

  get evrakSuccessCount() {
    return Object.values(this.evrakStatuses).filter(status => status === 'success').length;
  }

  get evrakPendingCount() {
    return Object.values(this.evrakStatuses).filter(status => status === 'pending').length;
  }

  get evrakErrorCount() {
    return Object.values(this.evrakStatuses).filter(status => status === 'error').length;
  }

  get pendingEvrakCount() {
    return this.xmlFiles.filter(file => this.evrakStatuses[file.name] === 'pending').length;
  }

  get getProgressText() {
    if (this.tab === 0) {
      return `Dosya İşleniyor (${this.currentChunk}/${this.totalChunks} parça)`;
    } else {
      return `Evrak İşleniyor (${this.currentChunk}/${this.totalChunks} parça)`;
    }
  }
}
